var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIduLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 872.27 494.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#59c16f;}.cls-3{fill:url(#radial-gradient);}.cls-4{fill:#7ac943;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 387.6,
    y1: 247.2,
    x2: 313.99,
    y2: 247.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#060c07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#19361f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2a5c35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#397b47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#459556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#4ea961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#54b669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#58bf6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#59c16f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 778.55,
    cy: 403.09,
    r: 156.23,
    gradientTransform: "matrix(0.85, 0.52, -1.23, 2.05, 611.77, -824.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0a150c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1c3d23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#2d6138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#3b7f49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#469757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#4eaa62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#54b769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#58bf6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#59c16f"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IDUlogoAsset 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Green_D_Gradient",
    "data-name": "Green D Gradient"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.52,292.78c13.52-63,63.6-112,126.77-124.58,52-10.38,101,3.73,136.88,32.29a.24.24,0,0,0,.39-.19V61.36A61.36,61.36,0,0,1,439.92,0h0a.25.25,0,0,1,.24.25V327.7c0,96.19-81.31,173.36-177.25,166.24C165.77,486.73,92.41,395.78,114.52,292.78Zm57.64,36.82c0,56.8,46.4,103.2,103.2,103.2s103.2-46.4,103.2-103.2-46.4-103.2-103.2-103.2S172.16,272.8,172.16,329.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Green_D_Gap",
    "data-name": "Green D Gap"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M439.92,0h0a61.36,61.36,0,0,0-61.36,61.36V200.3a.16.16,0,0,1,0,.12V325.88c0,.15,0,.29,0,.43,0,1.1.06,2.19.06,3.29,0,56.8-46.4,103.2-103.2,103.2s-103.2-46.4-103.2-103.2,46.4-103.2,103.2-103.2A103.2,103.2,0,0,1,358.79,269V187.25c-33.26-19.39-74.34-27.67-117.5-19.05C178.12,180.82,128,229.79,114.52,292.78c-22.11,103,51.25,194,148.39,201.16,95.94,7.12,177.25-70.05,177.25-166.24V.25A.25.25,0,0,0,439.92,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Green_I",
    "data-name": "Green I"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.4,102.46H0V40.86H62.4ZM0,164.86H62.4v329.6h0A62.4,62.4,0,0,1,0,432.06V164.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Green_U_Gradient",
    "data-name": "Green U Gradient",
    className: "cls-3",
    d: "M756,165.3h62V494.46h0a62.18,62.18,0,0,1-62-62.32V165.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Green_U",
    "data-name": "Green U"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M756.38,165.29v164.8c0,56.8-46.4,103.2-103.2,103.2S550,386.89,550,330.09V165.29H488.38v164.8a164.8,164.8,0,1,0,329.6,0V165.29Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M872.27,476.19a18.61,18.61,0,1,1-18.55-18.11A18.19,18.19,0,0,1,872.27,476.19Zm-32.57,0c0,8.06,6,14.46,14.13,14.46,7.95,0,13.8-6.4,13.8-14.35s-5.85-14.58-13.91-14.58S839.7,468.24,839.7,476.19Zm11.15,9.49h-4.19v-18.1a36.55,36.55,0,0,1,7-.56c3.42,0,5,.56,6.29,1.33a5,5,0,0,1,1.77,4c0,2-1.54,3.54-3.75,4.2v.22c1.76.66,2.76,2,3.31,4.42.55,2.76.88,3.86,1.32,4.52H858c-.55-.66-.89-2.32-1.44-4.41-.33-2-1.43-2.87-3.75-2.87h-2Zm.11-10.27h2c2.32,0,4.19-.77,4.19-2.65,0-1.65-1.21-2.76-3.86-2.76a10,10,0,0,0-2.32.23Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIduLogo);
export default __webpack_public_path__ + "static/media/idu-logo.9d4c35c6fa6aad26c115a98c962de32c.svg";
export { ForwardRef as ReactComponent };